module.exports = __webpack_public_path__ + "img/1424.44ab4c95.gif";